import React from 'react';
import TreeList from './Components/TreeList';
import { Grid, CssBaseline} from '@mui/joy';
import { CssVarsProvider } from '@mui/joy/styles';
import createStore from './store';
import MainGraph from './Components/MainGraph';
import TopBar from './Components/TopBar';
import { styled } from '@mui/joy/styles';
import Sheet from '@mui/joy/Sheet';
import { Provider, useSelector } from 'react-redux';
import IsobarSelector from './Components/IsobarSelector';
import { MathJaxContext } from "better-react-mathjax";
import { ListFocusProvider } from './Context/ListFocus';
import bootstrapTheme from './Internal/Theme';
import BackendInitializer from './Components/BackendInitializer';
import ChatWidget from './Components/ChatWidget';
const Item = styled(Sheet)(({ theme }) => ({
  backgroundColor: theme.vars.palette.background.surface,
  ...theme.typography['body-sm'],
  padding: theme.spacing(1),
  textAlign: 'center',
  borderRadius: 4,
  color: theme.vars.palette.text.secondary,
}));



const store = createStore();
// store.dispatch({ type: 'SET_DECAY', payload: 3 });
const config = {
  loader: { load: ["input/asciimath"] }
};
function Layout() {
  const mainGraph = useSelector(state => state.mainGraph);
  const graphOpen = mainGraph?.visible && mainGraph?.tuple;

  return (
    <div style={{ height: '100%', maxWidth: '100vw', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flexShrink: 0 }}>
        <TopBar />
      </div>
      <div style={{ flex: 1, display: 'flex', overflow: 'hidden', gap: '8px', padding: '0 8px 8px' }}>
        <div style={{ flex: graphOpen ? 1 : 3, overflow: 'hidden', minWidth: 0 }}>
          <TreeList />
        </div>
        {graphOpen && (
          <div style={{ flex: 2, overflow: 'hidden', minWidth: 0 }}>
            <MainGraph />
          </div>
        )}
        <div style={{ flex: '0 0 auto', overflow: 'hidden' }}>
          <IsobarSelector />
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <CssVarsProvider theme={bootstrapTheme} defaultMode="light">
      <CssBaseline/>
      <Provider store={store}>
        <MathJaxContext config={config}>
          <ListFocusProvider>
            <BackendInitializer />
            <ChatWidget />
            <Layout />
          </ListFocusProvider>
        </MathJaxContext>
      </Provider>
    </CssVarsProvider>
  );
};

export default App;
